import { Radio, RadioChangeEvent, RadioProps } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import FormField from '../Field';
import * as Styled from './RadioGroup.styles';

export type RadioOption = {
  value: any;
  label: string;
};

interface RadioGroupProps extends RadioProps {
  options?: RadioOption[];
}

const RadioGroup = ({ options = [], onChange, ...rest }: RadioGroupProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState();

  const handleChange = (e: RadioChangeEvent) => {
    onChange?.(e.target.value);
    setValue(e.target.value);
  };

  return (
    <Styled.RadioGroup {...rest} onChange={handleChange} value={value}>
      {options.map((option) => (
        <Radio key={option.value} value={option.value} checked={value === option.value}>
          {t(option.label)}
        </Radio>
      ))}
    </Styled.RadioGroup>
  );
};

export default FormField<any>(RadioGroup);
